const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/password-reset.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { useAuthStore } from '@/Utility/auth/Auth';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'react-toastify';
import { z } from 'zod';
import './login.less';
const passwordResetSearchSchema = z.object({
  login: z.string().optional().nullable().catch(null),
  key: z.string().optional().nullable().catch(null)
});
type PasswordResetSearch = z.infer<typeof passwordResetSearchSchema>;
export const Route = createFileRoute('/auth/password-reset')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (search): PasswordResetSearch => passwordResetSearchSchema.parse(search),
  beforeLoad: ({
    search
  }) => {
    const userExists = useAuthStore.getState()?.user?.userExists;
    if (userExists === true) {
      throw redirect({
        to: '/dash/catalog'
      });
    }
    if (!(search.login && search.key)) {
      toast.error('Invalid password reset link');
      throw redirect({
        to: '/auth/login'
      });
    }
  }
});